import React, { useState } from 'react';
import { Select } from 'antd';

const { Option } = Select;

const SearchableNumberSelect = ({
  minNumber = 50,
  maxNumber = 500,
  value,
  onChange,
  placeholder = "Type a number...",
  ...props
}) => {
  const [searchValue, setSearchValue] = useState('');

  const handleChange = (val) => {
    setSearchValue('');
    onChange?.(val);
  };

  const handleSearch = (val) => {
    setSearchValue(val);
  };

  const handleBlur = () => {
    setSearchValue('');
  };

  // Generate numbers in range
  const numbers = Array.from({ length: maxNumber - minNumber + 1 }, (_, i) => minNumber + i);

  // Filter numbers OR add typed number if it's valid and >= minNumber
  let filteredNumbers = numbers.filter(num =>
    num.toString().includes(searchValue)
  );

  // If user typed a complete number that's not in range but >= minNumber, add it
  const typedNumber = parseInt(searchValue);
  if (searchValue && !isNaN(typedNumber) && typedNumber >= minNumber && !filteredNumbers.includes(typedNumber)) {
    filteredNumbers = [typedNumber, ...filteredNumbers];
  }

  return (
    <Select
      showSearch
      value={value}
      placeholder={placeholder}
      onChange={handleChange}
      onSearch={handleSearch}
      onBlur={handleBlur}
      searchValue={searchValue}
      filterOption={false}
      style={{ width: '100%' }}
      {...props}
    >
      {filteredNumbers.map(num => (
        <Option key={num} value={num}>
          {num}
        </Option>
      ))}
    </Select>
  );
};

export default SearchableNumberSelect;


